import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'moment',
    pure: false,
    standalone: false
})
export class MomentPipe implements PipeTransform {
    transform(value: Date | string, dateFormat: string): any {
        return moment(value).format(dateFormat);
    }
}
